const HouseWithPriceTag = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width='121'
    height='106'
    viewBox='0 0 121 106'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    focusable='false'
  >
    <ellipse
      cx='76.5588'
      cy='61.8234'
      rx='43.9348'
      ry='44.0301'
      fill='white'
    />
    <path
      d='M75.9395 25.0539C75.9642 25.003 75.9796 24.9481 75.9851 24.8917L75.9395 25.0539Z'
      fill='#FEDFB3'
    />
    <path
      d='M45.3009 24.7454C45.1039 24.9066 44.9446 25.1091 44.8341 25.3386C44.7236 25.5682 44.6645 25.8192 44.6611 26.074L45.8944 26.0276C45.8909 25.9994 45.8909 25.9709 45.8944 25.9427C45.7695 25.5113 45.5685 25.1058 45.3009 24.7454V24.7454Z'
      fill='#FFAF84'
    />
    <path
      d='M55.2883 23.0303C56.9301 22.8218 58.7722 22.6595 60.8225 22.5823C62.5337 22.5128 64.0984 22.5128 65.532 22.5823L65.8403 21.3541C64.1754 21.3 62.4643 21.3 60.7763 21.3541C59.9901 21.385 59.2039 21.4313 58.4177 21.4931C55.7737 21.6645 53.1459 22.0311 50.5557 22.59L51.4883 23.6715C52.5982 23.4243 53.87 23.2003 55.2883 23.0303Z'
      fill='#FFAF84'
    />
    <path
      d='M76.3388 23.4403L75.9766 24.8848H76.5932H77.2098C77.1884 24.5923 77.0984 24.309 76.947 24.058C76.7957 23.8069 76.5873 23.5953 76.3388 23.4403V23.4403Z'
      fill='#FFAF84'
    />
    <path
      d='M46.0029 27.8355C45.8385 28.695 45.3877 29.4731 44.7245 30.0423C44.0612 30.6115 43.2246 30.938 42.3519 30.9685C41.4792 30.9989 40.6221 30.7315 39.9209 30.2099C39.2197 29.6883 38.716 28.9436 38.4924 28.0976C38.2688 27.2517 38.3385 26.3547 38.69 25.5536C39.0416 24.7525 39.6542 24.0948 40.4275 23.6883C41.2008 23.2818 42.0889 23.1505 42.9464 23.3159C43.8039 23.4813 44.5799 23.9337 45.1473 24.5989C45.209 24.6684 45.2475 24.7457 45.3014 24.8152C45.5772 25.1739 45.7861 25.5795 45.9181 26.0125C45.9181 26.1129 45.9643 26.2056 45.9874 26.306C46.5424 27.0785 49.8414 28.1291 55.5683 28.3917L52.4389 24.7457L51.4909 23.6565L50.5582 22.5751L43.1972 14.078L32.0902 16.5499L5.42871 39.8009L25.0914 62.4494L32.7993 55.7213L51.7529 39.2061L55.314 29.589L53.9574 29.5117C50.5659 29.2646 47.6292 28.7084 46.0029 27.8355Z'
      fill='#FF620F'
    />
    <path
      d='M75.4611 26.9467C73.0717 28.2444 68.5241 29.0787 63.8068 29.4417L61.6641 38.0392L74.7674 29.7507L75.4611 26.9467Z'
      fill='#91C5F0'
    />
    <path
      d='M65.5337 22.5598L64.1309 28.1756C71.4148 27.5654 75.4999 25.9741 75.9393 25.0858V24.9158L76.3016 23.4713L77.7506 17.6779L78.7141 13.9315L68.3316 11.3515L66.4818 18.7593L65.842 21.3316L65.5337 22.5598Z'
      fill='#91C5F0'
    />
    <path
      d='M93.2973 20.9763L92.0641 18.8057L90.3606 19.8794L74.7676 29.7515L61.6643 38.0399L50.0254 45.4015L116.637 62.1175L93.2973 20.9763Z'
      fill='#0D426E'
    />
    <path
      d='M50.0264 45.4011L39.8135 86.2796C42.0946 89.6838 44.8336 92.7563 47.953 95.41L54.628 68.7062C55.0211 67.1352 56.0205 65.7849 57.4065 64.952C58.7926 64.1192 60.4519 63.8719 62.0198 64.2645L74.0595 67.2848C75.6256 67.6805 76.9711 68.6828 77.8006 70.0716C78.6301 71.4605 78.8758 73.1225 78.4838 74.6927L70.7759 105.514C81.1593 106.873 91.6852 104.464 100.451 98.7239L92.805 96.7696L95.9806 84.2866L103.796 86.2873L100.667 98.5848C103.906 96.4379 106.847 93.8717 109.415 90.953L116.638 62.1171L50.0264 45.4011ZM87.9645 95.3714L80.1487 93.3707L83.3243 80.8956L91.1401 82.8885L87.9645 95.3714ZM92.2963 78.331L84.4805 76.338L87.6562 63.8551L95.4719 65.8481L92.2963 78.331ZM105.007 81.5753L97.1908 79.5901L100.366 67.1072L108.159 69.1001L105.007 81.5753Z'
      fill='#238CE2'
    />
    <path
      d='M74.0587 67.2854L62.019 64.2651C60.4511 63.8724 58.7918 64.1197 57.4057 64.9526C56.0197 65.7854 55.0203 67.1357 54.6272 68.7067L47.9521 95.4106C54.4278 100.919 62.358 104.429 70.7828 105.514L78.4907 74.6933C78.8825 73.122 78.6357 71.459 77.8047 70.07C76.9736 68.6809 75.6262 67.6793 74.0587 67.2854ZM59.7143 86.5969C59.5806 87.1269 59.2931 87.6053 58.8882 87.9717C58.4833 88.338 57.9791 88.5759 57.4393 88.6552C56.8995 88.7345 56.3484 88.6516 55.8556 88.4172C55.3628 88.1827 54.9504 87.8071 54.6705 87.3378C54.3906 86.8685 54.2558 86.3266 54.2831 85.7806C54.3105 85.2345 54.4987 84.7089 54.824 84.27C55.1493 83.8311 55.5971 83.4987 56.1108 83.3148C56.6245 83.1309 57.1811 83.1037 57.7103 83.2367C58.0627 83.3242 58.3944 83.4807 58.6862 83.6973C58.978 83.9139 59.2242 84.1862 59.4104 84.4986C59.5967 84.8109 59.7195 85.1572 59.7717 85.5173C59.8238 85.8774 59.8043 86.2443 59.7143 86.5969V86.5969Z'
      fill='#91C5F0'
    />
    <path
      d='M57.7099 83.2357C57.1808 83.1028 56.6241 83.1299 56.1104 83.3139C55.5967 83.4978 55.1489 83.8302 54.8236 84.2691C54.4983 84.708 54.3101 85.2336 54.2828 85.7797C54.2554 86.3257 54.3903 86.8676 54.6701 87.3369C54.95 87.8061 55.3624 88.1817 55.8552 88.4162C56.348 88.6507 56.8991 88.7335 57.4389 88.6542C57.9787 88.575 58.4829 88.3371 58.8878 87.9707C59.2927 87.6044 59.5802 87.126 59.7139 86.5959C59.8914 85.8841 59.7802 85.1308 59.4045 84.5009C59.0289 83.8711 58.4196 83.4162 57.7099 83.2357V83.2357Z'
      fill='#004272'
    />
    <path
      d='M77.2191 24.8379H76.6025H75.9859C75.9803 24.8943 75.9646 24.9493 75.9396 25.0001C75.5003 25.9194 71.4151 27.5106 64.1312 28.09C63.16 28.1749 62.1348 28.2367 61.048 28.2831C59.0286 28.3603 57.1941 28.3449 55.5677 28.2831C49.8639 28.0204 46.5419 26.9699 45.9869 26.1974C45.934 26.14 45.9015 26.0667 45.8944 25.9889L44.6611 26.0352C44.6611 26.6995 45.1776 27.2557 46.0023 27.7269C47.6287 28.6384 50.5654 29.1946 53.9568 29.4418L55.3134 29.519C57.1941 29.604 59.1673 29.6117 61.102 29.519C62.0064 29.4881 62.9082 29.434 63.8074 29.3568C68.5401 28.9937 73.0569 28.1595 75.4617 26.8618C76.5562 26.3442 77.25 25.6413 77.2191 24.8379Z'
      fill='#FFAF84'
    />
    <path
      d='M87.659 63.855L84.4854 76.3329L92.298 78.3286L95.4717 65.8507L87.659 63.855Z'
      fill='#0D426E'
    />
    <path
      d='M83.3251 80.8988L80.1514 93.3767L87.964 95.3725L91.1377 82.8946L83.3251 80.8988Z'
      fill='#0D426E'
    />
    <path
      d='M100.365 67.0988L97.1914 79.5767L105.004 81.5725L108.178 69.0946L100.365 67.0988Z'
      fill='#0D426E'
    />
    <path
      d='M95.9969 84.2863L92.8213 96.7692L100.468 98.7235L100.683 98.5845L103.813 86.2869L95.9969 84.2863Z'
      fill='#0D426E'
    />
  </svg>
);

export default HouseWithPriceTag;
